import { render } from "./TenantConfigurationEditor.vue?vue&type=template&id=a69756e0"
import script from "./TenantConfigurationEditor.vue?vue&type=script&lang=js"
export * from "./TenantConfigurationEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__